type Listener = (refused: boolean) => void;

class ConnectionBus {
  private listeners: Set<Listener> = new Set();
  private refused = false;

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    try { listener(this.refused); } catch {}
    return () => this.listeners.delete(listener);
  }

  setRefused(refused: boolean) {
    this.refused = refused;
    this.emit();
  }

  private emit() {
    this.listeners.forEach((l) => {
      try { l(this.refused); } catch {}
    });
  }
}

export const connectionBus = new ConnectionBus();